import { apiRequest, HTTP_GET, HTTP_POST, ApiRequestFailure } from 'helpers/http';
import SalesDataOrder from 'mage-swagfaces/sales/SalesDataOrder';
import { Either } from 'fp-ts/lib/Either';

export interface OrdersResponse {
  items: SalesDataOrder[];
  total_count: number;
}

interface NPSSubmissionPost {
  email: string;
  orderId: string;
  rating: string;
  reason: string;
  occasion: string;
  occasionSpecify: string;
  lead: string;
  leadSpecify: string;
}

const magenumRequest = apiRequest(process.env.GATSBY_MAGENUM_BASE_URL);

export const submitOrderFeedback = (formData: NPSSubmissionPost): Promise<Either<ApiRequestFailure, object>> =>
  magenumRequest('track', 'nps')(HTTP_POST)()<object>(formData);

export const getCustomerOrders = (
  page: number,
  pageSize: number
): Promise<Either<ApiRequestFailure, OrdersResponse>> => {
  const queryParams = `page=${page}&pageSize=${pageSize}`;
  return magenumRequest('sales', `order?${queryParams}`)(HTTP_GET)()<OrdersResponse>();
};

export const getAllCustomerOrders = (): Promise<Either<ApiRequestFailure, OrdersResponse>> => {
  return magenumRequest('sales', 'order')(HTTP_GET)()<OrdersResponse>();
};

export const addReorderItemsToCart = (orderId: number): Promise<Either<ApiRequestFailure, OrdersResponse>> =>
  magenumRequest('sales', `order/reorder/${orderId}`)(HTTP_POST)()<OrdersResponse>();

export const cancelOrder = (orderId: number): Promise<Either<ApiRequestFailure, string>> =>
  magenumRequest('sales', `order/cancel/${orderId}`)(HTTP_POST)()<string>();
